export type ApiError = {
  error: string
}

export class ApiErrorModule {
  static isApiError(e: any): e is ApiError {
    return typeof e?.error === "string"
  }
}
